const LEO = ({ ...props }) => (
  <svg
    width="337"
    height="337"
    viewBox="0 0 337 337"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M97.3034 146.534H97.4349L99.6605 147.319L101.884 148.104L104.11 148.889L106.336 149.806L108.561 150.591L110.785 151.376L113.011 152.161L115.236 153.078L117.462 153.863L119.556 154.648L121.78 155.433L124.006 156.35L126.231 157.135L128.455 157.922L130.681 158.707L132.906 159.622L135.132 160.408L137.356 161.193L139.582 161.979L141.807 162.895L144.031 163.68V132.136H94.2927L92.0688 133.182L86.9639 135.932L81.7276 138.68L76.4929 141.298L71.388 144.046L66.1517 146.795L60.9171 149.413L55.8122 152.161L50.5759 154.911L45.3412 157.527L40.2347 160.277L35.524 162.764L35 240.119L40.2363 243.785L45.3412 247.449L50.5759 250.984L55.8122 254.649L60.9171 258.313L66.1517 261.979L68.5087 263.681L71.388 260.015L76.4929 253.208L77.0152 252.554L76.4929 252.162L71.388 248.497L66.1517 244.831L60.9171 241.167L55.8122 237.502L50.5759 233.836L49.137 232.922L49.5296 170.355L50.5775 169.831L55.8122 167.213L60.9171 164.597L66.1517 162.11L71.388 159.492L76.4929 156.874L81.7276 154.255L86.9639 151.769L92.0688 149.151L97.3034 146.534V146.534Z"
      fill="url(#paint0_linear_8023_3815)"
    />
    <path
      d="M186.835 294.177L182.254 295.879L177.41 297.842L172.568 299.806L167.856 301.769L165.499 302.685L163.012 301.376L158.17 298.889L153.326 296.532L148.484 294.046L143.64 291.559L138.798 289.204L133.954 286.717L129.112 284.23L124.268 281.873L119.426 279.386L114.714 277.031L109.87 274.544L105.028 272.058L104.504 271.795V208.706H90.4985V280.434L95.3423 282.79L100.184 285.276L105.028 287.763L109.87 290.12L114.714 292.607L119.426 295.094L124.268 297.449L129.112 299.936L133.954 302.422L138.798 304.78L143.64 307.266L148.484 309.753L153.326 312.11L158.17 314.597L163.012 317.083L164.845 318L167.856 316.691L172.568 314.858L177.41 312.895L182.254 310.931L187.096 309.099L191.94 307.135L187.096 294.962L186.835 294.177V294.177Z"
      fill="url(#paint1_linear_8023_3815)"
    />
    <path
      d="M272.959 206.351L273.221 236.062L271.911 237.11L263.666 242.869L255.551 248.759L247.305 254.649L239.058 260.539L230.943 266.297L222.697 272.187L214.452 278.077L209.608 281.612L206.336 278.994L198.089 272.711L189.844 266.429L181.598 260.146L173.483 253.863L172.174 252.816V220.747L173.483 219.438L181.598 210.8L189.844 202.292L198.089 193.654L206.336 185.146L214.189 176.769H116.021L124.268 185.407L132.382 193.915L140.629 202.424L148.875 211.061L156.99 219.57L158.168 220.747V259.622L165.236 265.12L173.483 271.402L181.598 277.685L189.844 283.967L198.089 290.25L206.336 296.534L209.215 298.889L214.452 295.094L222.697 289.335L230.943 283.445L239.058 277.555L247.305 271.795L255.551 265.905L263.666 260.015L271.911 254.256L280.159 248.366L286.965 243.393L288.272 206.873L280.159 206.612L272.959 206.351V206.351Z"
      fill="url(#paint2_linear_8023_3815)"
    />
    <path
      d="M48.3518 137.241H49.2683L49.5295 97.5809L54.7658 94.3091L61.3112 90.2504L67.8549 86.3232L74.4003 82.2662L80.8126 78.339L87.358 74.4134L93.9017 70.3548L100.316 66.4292L106.859 62.3706L113.405 58.445L113.536 58.3136L119.819 61.978L126.363 65.6441L132.908 69.4399L139.32 73.1043L145.866 76.7688L152.409 80.4332L158.823 84.229L165.106 87.7637L165.369 87.2397L171.912 75.5911L165.369 71.7953L158.823 68.1309L152.409 64.4648L145.866 60.8004L139.32 57.0045L132.908 53.3401L126.363 49.674L119.819 46.0096L113.405 42.3452L113.144 42.2138L106.859 46.0096L100.316 50.0682L93.9017 53.9938L87.358 58.0525L80.8126 61.978L74.4003 65.9053L67.8549 69.9622L61.3112 73.8895L54.7658 77.9464L48.3518 81.8737L41.8081 85.8009L35.5255 89.7265L35.2627 137.109H41.8081L48.3518 137.241V137.241Z"
      fill="url(#paint3_linear_8023_3815)"
    />
    <path
      d="M302.147 100.853L298.875 98.2347L295.472 95.4868L292.068 92.7372L288.665 89.9893L285.262 87.3712L281.859 84.6216L278.455 81.8737L275.054 79.1241L271.65 76.3762L269.032 74.4135L268.116 75.4597L264.712 79.6481L261.309 83.9679L260.393 85.1456L261.309 86.0621L264.712 88.9414L268.116 91.6909L271.65 94.5702L275.054 97.4496L278.455 100.329L281.859 103.208L285.262 106.087L286.963 107.528L287.095 171.272L285.262 172.45L281.859 174.675L278.455 176.769L275.054 178.993L271.65 181.087L268.116 183.313L264.712 185.407L261.309 187.633L257.906 189.727L254.503 191.953L251.099 194.047L247.696 196.271L244.294 198.365L240.891 200.591L237.488 202.685L234.085 204.91L230.681 207.005L234.085 212.371L237.488 217.868L238.142 218.785L240.891 217.083L244.294 214.989L247.696 212.895L251.099 210.8L254.503 208.575L257.906 206.481L261.309 204.386L264.712 202.292L268.116 200.198L271.65 198.104L275.054 195.878L278.455 193.784L281.859 191.69L285.262 189.596L288.665 187.501L292.068 185.407L295.472 183.182L298.875 181.087L302.278 178.993L302.147 100.853V100.853Z"
      fill="url(#paint4_linear_8023_3815)"
    />
    <path
      d="M190.89 138.942V166.56L192.068 166.167L196.519 164.334L201.1 162.503L205.55 160.67L210.132 158.836L214.713 157.005L219.163 155.172L223.744 153.339L228.324 151.508L232.776 149.675L237.357 147.842L241.806 146.01V62.3706L236.703 59.2301L231.467 56.2194L226.23 53.2087L220.996 50.0666L215.759 47.0575L210.654 44.0468L205.42 40.9047L200.183 37.894L194.949 34.7535L189.713 31.7428L184.476 28.7321L179.373 25.5917L174.137 22.5809L168.9 19.5702L166.152 18L163.666 19.3074L158.429 22.1884L153.195 24.9363L148.09 27.8156L142.854 30.6949L137.619 33.4444L132.383 36.3238L137.619 39.3345L142.854 42.3452L146.127 44.308L148.09 43.26L153.195 40.5121L158.429 37.7642L163.666 35.0147L165.76 33.9668L168.9 35.7998L174.137 38.8105L179.373 41.8212L184.476 44.8319L189.713 47.9724L194.949 50.9831L200.183 53.9938L205.42 57.1359L210.654 60.1466L215.759 63.1557L220.996 66.2978L226.23 69.3085L227.932 70.2251V131.873H191.022"
      fill="url(#paint5_linear_8023_3815)"
    />
    <path
      d="M190.89 166.56L241.806 146.01L190.89 131.873"
      fill="url(#paint6_linear_8023_3815)"
    />
    <path
      d="M144.033 166.56V132.397L97.4351 146.271L144.033 166.428"
      fill="url(#paint7_linear_8023_3815)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8023_3815"
        x1="89.5138"
        y1="132.083"
        x2="89.5138"
        y2="263.636"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBE900" />
        <stop offset="0.102" stop-color="#FAE300" />
        <stop offset="0.277" stop-color="#F8D200" />
        <stop offset="0.504" stop-color="#F4B400" />
        <stop offset="0.77" stop-color="#EE8403" />
        <stop offset="1" stop-color="#E9500E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8023_3815"
        x1="141.223"
        y1="208.718"
        x2="141.223"
        y2="317.945"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBE900" />
        <stop offset="0.102" stop-color="#FAE300" />
        <stop offset="0.277" stop-color="#F8D200" />
        <stop offset="0.504" stop-color="#F4B400" />
        <stop offset="0.77" stop-color="#EE8403" />
        <stop offset="1" stop-color="#E9500E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8023_3815"
        x1="202.171"
        y1="176.781"
        x2="202.171"
        y2="298.876"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBE900" />
        <stop offset="0.102" stop-color="#FAE300" />
        <stop offset="0.277" stop-color="#F8D200" />
        <stop offset="0.504" stop-color="#F4B400" />
        <stop offset="0.77" stop-color="#EE8403" />
        <stop offset="1" stop-color="#E9500E" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8023_3815"
        x1="103.598"
        y1="42.1855"
        x2="103.598"
        y2="137.199"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBE900" />
        <stop offset="0.102" stop-color="#FAE300" />
        <stop offset="0.277" stop-color="#F8D200" />
        <stop offset="0.504" stop-color="#F4B400" />
        <stop offset="0.77" stop-color="#EE8403" />
        <stop offset="1" stop-color="#E9500E" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_8023_3815"
        x1="266.476"
        y1="74.3602"
        x2="266.476"
        y2="218.808"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBE900" />
        <stop offset="0.102" stop-color="#FAE300" />
        <stop offset="0.277" stop-color="#F8D200" />
        <stop offset="0.504" stop-color="#F4B400" />
        <stop offset="0.77" stop-color="#EE8403" />
        <stop offset="1" stop-color="#E9500E" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_8023_3815"
        x1="187.134"
        y1="17.9584"
        x2="187.134"
        y2="166.611"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBE900" />
        <stop offset="0.102" stop-color="#FAE300" />
        <stop offset="0.277" stop-color="#F8D200" />
        <stop offset="0.504" stop-color="#F4B400" />
        <stop offset="0.77" stop-color="#EE8403" />
        <stop offset="1" stop-color="#E9500E" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_8023_3815"
        x1="216.348"
        y1="131.915"
        x2="216.348"
        y2="166.611"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBE900" />
        <stop offset="0.102" stop-color="#FAE300" />
        <stop offset="0.277" stop-color="#F8D200" />
        <stop offset="0.504" stop-color="#F4B400" />
        <stop offset="0.77" stop-color="#EE8403" />
        <stop offset="1" stop-color="#E9500E" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_8023_3815"
        x1="120.173"
        y1="157.945"
        x2="131.192"
        y2="127.675"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FBE900" />
        <stop offset="0.102" stop-color="#FAE300" />
        <stop offset="0.277" stop-color="#F8D200" />
        <stop offset="0.504" stop-color="#F4B400" />
        <stop offset="0.77" stop-color="#EE8403" />
        <stop offset="1" stop-color="#E9500E" />
      </linearGradient>
    </defs>
  </svg>
);
export default LEO;
